enum DonationArea {
    Select = 0,
    MemberDetails = 1,
    SponsorMember = 2,
    GroupMembers = 3,
    GiftAid = 4,
    Payment = 5,
    Summary = 6
}

export default DonationArea;


// WEBPACK FOOTER //
// ./src/MakeDonation/Types/DonationArea.ts